import * as React from 'react'
import dp from '../../assets/profile.jpg'
import mailLogo from '../../assets/email.png'
import githubLogo from '../../assets/github.png'
import twtrLogo from '../../assets/twitter.png'
import linkedinLogo from '../../assets/linkedin.png'
import './styles.css'

export default () => (
    <section className='home'>
        <div className='dp-main'>
            <img src={dp} />
        </div>
        <div className='metadata'>
            <h2 className='name'>Neek Sandhu</h2>
            <h3>Software Engineer</h3>
            <h4>Node.js, TypeScript, C++, React</h4>
            <div className='links'>
                <a target='_blank' href='mailto:neek.sandhu@outlook.com' title='Email'><img src={mailLogo} width='20' /></a>
                <a target='_blank' href='https://github.com/neeksandhu' title='GitHub'><img src={githubLogo} width='20' /></a>
                <a target='_blank' href='https://twitter.com/neek_sandhu' title='Twitter'><img src={twtrLogo} width='20' /></a>
                <a target='_blank' href='https://www.linkedin.com/in/neeksandhu/' title='LinkedIn'><img src={linkedinLogo} width='20' /></a>
            </div>
        </div>
    </section>
)


// WEBPACK FOOTER //
// ./src/components/Home/index.tsx